// src/components/GuestPromptWrapper.js (Updated to be less frequent)
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import LoginPromptModal from './LoginPromptModal';

const GuestPromptWrapper = () => {
    const [isPromptVisible, setIsPromptVisible] = useState(false);
    const token = localStorage.getItem('app_token');

    useEffect(() => {
        // Only proceed if the user is a guest
        if (!token) {
            // Check if the guest has ever seen the prompt on this device
            const hasSeenPrompt = localStorage.getItem('hasSeenLoginPrompt'); // CHANGED
            if (!hasSeenPrompt) {
                // Show the prompt after a short delay
                const timer = setTimeout(() => {
                    setIsPromptVisible(true);
                }, 1500); // 1.5-second delay
                return () => clearTimeout(timer);
            }
        }
    }, [token]);

    const handleClosePrompt = () => {
        // Remember that the guest has dismissed the prompt permanently on this device
        localStorage.setItem('hasSeenLoginPrompt', 'true'); // CHANGED
        setIsPromptVisible(false);
    };

    return (
        <>
            {isPromptVisible && <LoginPromptModal onClose={handleClosePrompt} />}
            <Outlet />
        </>
    );
};

export default GuestPromptWrapper;